import React from 'react';
import PropTypes from 'prop-types';
import {
  Column,
  Direction,
  Grid,
  Heading,
  Margin,
  SubHeading,
  Ruler
} from '@scotia/canvas-react';

export const InformationPage = props => (
  <Grid center={true}>
    <Direction>
      <Column
        mdOffset={1}
        md={10}
        lg={8}
        lgOffset={2}
        sm={12}
        xs={12}
        className={'hide--xs'}
      >
        <Margin side="top" xs={24} sm={24} md={36} lg={36}>
          <SubHeading>{props.title}</SubHeading>
        </Margin>
      </Column>
      <Column mdOffset={1} md={10} lg={8} lgOffset={2} sm={12} xs={12}>
        <Margin side="top" xs={24} sm={24} md={24} lg={24}>
          <Heading>{props.subtitle}</Heading>
        </Margin>
      </Column>

      <Column mdOffset={1} md={10} lg={8} lgOffset={2} sm={12} xs={12}>
        <Margin side="top" xs={12} md={36}>
          <Ruler />
        </Margin>
      </Column>
    </Direction>
    <Margin side="top" xs={24} md={24} style={{ width: '100%' }}>
      {props.children}
    </Margin>
  </Grid>
);
InformationPage.propTypes = {
  subtitle: PropTypes.string,
  title: PropTypes.string
};

InformationPage.defaultProps = {
  subtitle: '',
  title: ''
};
